import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, ArrowLeft } from 'lucide-react';
import { useLeadKanbanQuery } from '../../api/leadsApi';
import { LEAD_STATUS, LEAD_PRIORITY } from '../../utils/status';

export default function LeadsKanbanPage() {
  const { data, isLoading } = useLeadKanbanQuery();

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb"><span>Home</span><span className="bc-sep">/</span><Link to="/leads" style={{ color: 'inherit' }}>Leads</Link><span className="bc-sep">/</span><span className="bc-cur">Kanban</span></div>
        <div className="page-header-row">
          <div>
            <h1>Lead Pipeline</h1>
            <div className="page-header-sub">Drag-and-drop coming soon — for now, change status from the lead detail.</div>
          </div>
          <Link to="/leads" className="btn btn-outline"><ArrowLeft size={16} /> Back to list</Link>
        </div>
      </div>

      {isLoading && <div className="skeleton" style={{ height: 200 }} />}

      <div className="kanban-board">
        {(data ?? []).map((col) => {
          const meta = LEAD_STATUS[col.status] || { label: col.status, color: 'b-gray' };
          return (
            <div key={col.status} className="kanban-col">
              <div className="kanban-col-head">
                <h4><span className={`badge ${meta.color}`}>{meta.label}</span></h4>
                <span className="k-count">{col.count}</span>
              </div>
              <div className="kanban-cards">
                {col.items.map((l) => {
                  const pri = LEAD_PRIORITY[l.priority] || { label: l.priority, color: 'b-gray' };
                  return (
                    <div key={l.id} className="k-card">
                      <div className="k-card-name">{l.fullName}</div>
                      <div className="k-card-row"><Phone size={11} /> {l.phoneNumber}</div>
                      {l.email && <div className="k-card-row"><Mail size={11} /> {l.email}</div>}
                      <div style={{ marginTop: 6, display: 'flex', gap: 4 }}>
                        <span className={`badge ${pri.color}`}>{pri.label}</span>
                        <span className="badge b-gray">{l.source}</span>
                      </div>
                    </div>
                  );
                })}
                {col.items.length === 0 && (
                  <div style={{ padding: 16, textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.78rem' }}>
                    No leads
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
